import { writable } from 'svelte/store';

export const modal = writable(null);
export const toasts = writable([]);

// Overlay modal — rendered ON TOP of the singleton `modal` so a confirmation
// dialog can ask "are you sure?" without unmounting the parent modal. The
// parent's local state survives because it stays in `modal` the whole time.
// Use this for any "are you sure?" prompt that should NOT close the modal
// underneath when the user cancels.
export const overlayModal = writable(null);

// Show modal with optional props
export const showModal = (modalComponent, { ...props } = { blur: false }) => {
  modal.set({ modalComponent, props });
};
export const closeModal = () => modal.set(null);

export const showOverlayModal = (
  modalComponent,
  { ...props } = { blur: false },
) => {
  overlayModal.set({ modalComponent, props });
};
export const closeOverlayModal = () => overlayModal.set(null);

// Set timeout to false to disable auto close
export const showToast = (message, type = 'info', timeout = 4000) => {
  const id = new Date().getTime() + Math.random() * 1000;
  toasts.update((toasts) => [...toasts, { id, message, type, timeout }]);
  if (timeout) setTimeout(() => closeToast(id), timeout);
  return id;
};

export const closeToast = (id) =>
  toasts.update((toasts) => toasts.filter((toast) => toast.id !== id));
